// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2MAw7","productName":"Table_productName__2NM0N"};